import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { globals } from "../../globals";
import { Observable } from "rxjs";
import { QueryFilterService } from "./query-filter-service";
import { IGridifyQuery } from "gridify-client";
import { TipoSituacaoCadastral } from "../../dominio/enums";
import { PaginatedModel } from "../../dominio/paginated-model";
import { TipoAnexoModel } from "../../dominio/tipo-anexo-model";


export class TipoAnexoGetOneResponse {
  result: TipoAnexoModel;
}

export class TipoAnexoGetManyResponse {
  results: TipoAnexoModel[];
  pagination: PaginatedModel
}

export class TipoAnexoCreationRequest {
  idObjetivo: number | undefined;
  nome: string;
  descricao: string | undefined;
  situacao: TipoSituacaoCadastral;
}

export class TipoAnexoUpdateRequest {
  idObjetivo: number | undefined;
  nome: string;
  descricao: string | undefined;
  situacao: TipoSituacaoCadastral;
}

@Injectable({
  providedIn: 'root'
})
export class TipoAnexoService {
  constructor(
    private http: HttpClient,
    private queryFilterService: QueryFilterService
  ) {

  }

  buscarPorId(idTipoAnexo: number): Observable<TipoAnexoGetOneResponse> {
    return this.http.get<TipoAnexoGetOneResponse>(`${globals.apiUrl}/api/v2/core/config/tipos-anexo/${idTipoAnexo}`);
  }

  buscarTodos(queryFilter: IGridifyQuery | null = null): Observable<TipoAnexoGetManyResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<TipoAnexoGetManyResponse>(`${globals.apiUrl}/api/v2/core/config/tipos-anexo`, { params });
  }

  cadastrar(data: TipoAnexoCreationRequest): Observable<TipoAnexoGetOneResponse>{
    return this.http.post<TipoAnexoGetOneResponse>(
      `${globals.apiUrl}/api/v2/core/config/tipos-anexo`,
      data
    );
  }

  atualizar(idTipoAnexo: number, data: TipoAnexoUpdateRequest): Observable<TipoAnexoGetOneResponse>{
    return this.http.put<TipoAnexoGetOneResponse>(
      `${globals.apiUrl}/api/v2/core/config/tipos-anexo/${idTipoAnexo}`,
      data
    );
  }

  excluir(idTipoAnexo: number): Observable<void>{
    return this.http.delete<void>(
      `${globals.apiUrl}/api/v2/core/config/tipos-anexo/${idTipoAnexo}`
    );
  }
}
